export const samplePrompt: { label: string; value: string }[] = [
  {
    label: 'AI Psychologist',
    value:
      'Calming sage-to-peach gradient background, centered bold white sans-serif headline "Turn worry into workable steps", soft drop-shadow. Around the text: minimalist overlapping chat-bubble icons and a tiny sprig of greenery, slight paper-cut depth effect. Modern flat design, high resolution, crisp edges, gentle vignette. --no people, no faces, no watermark, no logo, no clutter',
  },
  {
    label: 'Smart Investing Tips for Gen Z: Build Your Wealth Early',
    value:
      '16:9 premium finance thumbnail — vibrant electric-blue to deep-violet gradient with subtle grid; centered bold white headline "BUILD WEALTH EARLY", smaller neon-mint kicker above "Smart Investing Tips for Gen Z". Hero visuals: sleek 3-D stacked coins and a glass smartphone showing a generic rising line chart, dynamic upward arrow sweeping left-to-right, soft glow and reflections for depth. High-contrast typography, crisp edges, studio-quality realism, gentle vignette --no humans, faces, brand logos, watermarks, bank names, text clutter, tiny illegible copy, cartoon style',
  },
  {
    label: 'Budget Travel Hacks',
    value:
      '16:9 premium travel thumbnail — ocean-blue to sunset-coral gradient with faint map contours; headline "TRAVEL MORE, SPEND LESS", small white kicker above "Budget travel hacks". Hero visuals: photoreal passport silhouette, piggy-bank icon, and a dashed airplane path curving upward; glossy highlights, high contrast --no humans, faces, airline logos, watermarks, clutter, cartoon style',
  },
  {
    label: '25 Phrases for your trip to Italy',
    value:
      'Pro YouTuber thumbnail, 16:9 — split layout: left 40% solid green organic shape over dark background for the text; right 60% softly defocused, warm-toned Italian scenery (classic architecture/arches, tiled roofs, coastline) with no people. Text exactly: big red "25" with white stroke; stacked bold white uppercase "PHRASES FOR YOUR TRIP TO"; oversized "ITALY". Small circular Italian flag badge in top-right. High contrast, crisp vector lettering, subtle drop shadows, safe margins. --no humans, faces, brand logos, extra text, clutter',
  },
] as const

export const generateFileFromUrl = async (
  url: string,
): Promise<{ file: File; dataUrl: string; blob: Blob }> => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error('Failed to fetch image from URL')
  }
  const blob = await response.blob()
  const file = new File([blob], 'image.png', { type: blob.type })

  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsDataURL(blob)
  })

  return { file, dataUrl, blob }
}

export const getFileExtension = (url: string) => {
  if (url.startsWith('data:')) {
    // Extract MIME type from data URL
    const mimeType = url.split(',')[0].split(':')[1].split(';')[0]
    switch (mimeType) {
      case 'image/png':
        return 'png'
      case 'image/jpeg':
      case 'image/jpg':
        return 'jpg'
      case 'image/gif':
        return 'gif'
      case 'image/webp':
        return 'webp'
      default:
        return 'png'
    }
  } else {
    return url.split('.').pop()?.split(/[?#]/)[0] || 'png'
  }
}
